var map = {
	"./cancel.json": [
		71696,
		1696
	],
	"./done.json": [
		6742,
		6742
	],
	"./error.json": [
		93420,
		3420
	],
	"./logo-single-static.json": [
		22317,
		2317
	],
	"./warning.json": [
		70650,
		650
	],
	"./working.json": [
		51557,
		1557
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 13406;
module.exports = webpackAsyncContext;